// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1INFI","label":"styles_label__2Nx-l"};